// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "RoundedAppointmentTypesList-module--wrapper--+J-kv";
export var item = "RoundedAppointmentTypesList-module--item--UmQgS";
export var otherItem = "RoundedAppointmentTypesList-module--otherItem--WWE1n";
export var icon = "RoundedAppointmentTypesList-module--icon--+1ID8";